<template>
    <slot v-if="has" />

    <slot name="fallback" v-else />
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { hasAddon } from '~/plugins/addon';

const props = defineProps<{
    name: string | string[];
    matchAny?: boolean;
}>();

const has = computed(() => hasAddon(props.name, props.matchAny ?? false));
</script>
